module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAATpJREFUSIntlD1OAkEYhp93RIIFZg/g7w04ghYk0nkDPAIUamsrFnAFbkCniQUeAU+gQXqJFBKU/WxYs0aWHbJu51tNvp15np3JNyMWqQ2vT81oSzogQ8zsWaJ5u3fZAxBAddSqFOb0EY8mXWURYGFHpv3PDY7vdy4GOnptB1tvH08AoXTmZOMs/NAUOKyHMX7f3jwslCazDlIAsPiQKS4CiKA0mXWcUD0bMjlCdZcXPMq/IDUFr1lmTXNuEC8pDCtI7T8RmHODu93zh3jt5OUGWXpP535Eqg1bP3/DGEfXfB1Q7LkJ4vXfOxBBYU6/OmpVssKXC9aUrIInCzwlafDVghSJDzxdkCDxhcOyLkrKorsAfOHge5PheyfR2HeZv2BNcJT8X1PDunnBDeu6abnYyENiWHdaLja+ADpjhwvTV+QEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_transaction_receive_green.png
// module id = 182
// module chunks = 1